__turbopack_context__.v({
  "bottomText": "finsightModal-module-scss-module__ZRePLq__bottomText",
  "centerContainer": "finsightModal-module-scss-module__ZRePLq__centerContainer",
  "centeredText": "finsightModal-module-scss-module__ZRePLq__centeredText",
  "closeButton": "finsightModal-module-scss-module__ZRePLq__closeButton",
  "hideModalInvisible": "finsightModal-module-scss-module__ZRePLq__hideModalInvisible",
  "logo": "finsightModal-module-scss-module__ZRePLq__logo",
  "modalDescriptionContainer": "finsightModal-module-scss-module__ZRePLq__modalDescriptionContainer",
  "modalLeftSide": "finsightModal-module-scss-module__ZRePLq__modalLeftSide",
  "modalRightSide": "finsightModal-module-scss-module__ZRePLq__modalRightSide",
  "modalWrp": "finsightModal-module-scss-module__ZRePLq__modalWrp",
});
